import { iconSizes } from '@/theme/tokens';
import { Stack } from '@/ui/layout/Stack';
import { Box, CircularProgress, Text } from '@/ui/primitives';
import type { ReactElement } from 'react';

type PageLoadingFallbackProps = {
  message: string;
};

export const PageLoadingFallback = ({ message }: PageLoadingFallbackProps): ReactElement => (
  <Box
    sx={{
      minHeight: '45vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Stack gap="md" align="center">
      <Text
        role="body"
        color="textSecondary"
        align="center"
        sx={{ fontSize: (theme) => theme.typography.subtitle1.fontSize }}
      >
        {message}
      </Text>
      <CircularProgress size={iconSizes.lg} />
    </Stack>
  </Box>
);
